import apiClient from "utils/apiClient";
import { PAYMENT_SERVICE_BASE_URL } from "constants";

const API_V1 = `${PAYMENT_SERVICE_BASE_URL}/api/v1`;

const unwrap = (response) => response.data;

const withPagination = (params = {}) => {
  const { page = 0, size = 20, ...rest } = params;
  return { page, size, ...rest };
};

export const paymentService = {
  businessGrowthPartners: {
    list: async (params = {}) =>
      apiClient
        .get(`${API_V1}/business-growth-partners`, { params: withPagination(params) })
        .then(unwrap),

    get: async (id) =>
      apiClient.get(`${API_V1}/business-growth-partners/${id}`).then(unwrap),

    create: async (data, actorId) =>
      apiClient
        .post(`${API_V1}/business-growth-partners`, data, {
          headers: { "O-ACTOR-ID": actorId },
        })
        .then(unwrap),

    update: async (id, data, actorId) =>
      apiClient
        .patch(`${API_V1}/business-growth-partners/${id}`, data, {
          headers: { "O-ACTOR-ID": actorId },
        })
        .then(unwrap),

    cancel: async (id, data, actorId) =>
      apiClient
        .patch(`${API_V1}/business-growth-partners/${id}/cancel`, data, {
          headers: { "O-ACTOR-ID": actorId },
        })
        .then(unwrap),
  },
};

export default paymentService;
